module.exports = __webpack_public_path__ + "static/media/pdf.d62fd747.svg";